import css from 'styled-jsx/css';

const staticStyles = css.global`
  .NewBaseTable {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    background-color: #fff;

    &__actions {
      display: flex;
      gap: 16px;
      margin: 8px 0;
      justify-content: flex-end;

      &-reload {
        div {
          display: flex;
        }

        svg {
          width: 16px;
          height: 16px;

          path {
            fill: rgba(0, 0, 0, 0.25);
          }
        }
      }
    }

    &__visibility {
      position: relative;
      display: flex;
      justify-content: flex-end;

      &__toggle-button {
        display: flex;
        gap: 12px;
        align-items: center;
        padding: 8px 12px;
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        background-color: #fff;
        font-size: 14px;

        &-checkbox {
          display: flex;
          color: rgba(51, 51, 51, 0.25);
        }
      }

      &__dropdown-menu {
        position: absolute;
        top: 40px;
        right: 0;
        z-index: 20;
        min-width: 224px;
        overflow: auto;
        max-height: 236px;
        padding: 24px 16px;
        display: flex;
        gap: 16px;
        flex-direction: column;
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        background-color: #fff;
        box-shadow: 0 36px 50px 0 rgba(0, 0, 0, 0.07), 0 8.041px 11.168px 0 rgba(0, 0, 0, 0.04),
          0 2.394px 3.325px 0 rgba(0, 0, 0, 0.03);
      }

      &__checkbox-label {
        text-transform: capitalize;
        font-size: 14px;
      }
    }

    &__draghandle {
      background: transparent;
      border: 0;
      line-height: 1;
      user-select: none;
      color: #333;

      svg {
        color: rgba(51, 51, 51, 0.25);
      }

      &:active {
        cursor: grabbing;
      }
    }

    &__wrapper {
      width: 100%;
      overflow: auto;
      overflow-y: hidden;
    }

    &__col {
      position: relative;
      text-align: left;
      padding: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      opacity: 1;
      font-size: 14px;
      color: #1d1d1d;
      background: #fff;
      z-index: 1;

      &:first-child {
        border-left: 1px solid #e5e5e5;
      }

      &:last-child {
        border-right: 1px solid #e5e5e5;
      }

      &-dragging {
        opacity: 0.9;
        z-index: 3;
      }

      :global(.RowLink) {
        overflow: hidden;
      }
    }

    &__head {
      &__col {
        z-index: 3;
        position: relative;
        overflow: visible;
        text-align: left;
        user-select: none;
        color: rgba(51, 51, 51, 0.25);

        &-dragging {
          opacity: 0.9;
          z-index: 4;
        }

        &-with-sort {
          padding: 0;
          padding-left: 8px;
        }

        &__inner {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        &-label {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          overflow: hidden;

          span {
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 12px;
          }
        }

        &-arrow {
          color: rgba(51, 51, 51, 0.25);
          margin-left: auto;
          padding: 8px;

          &--up {
            svg {
              path:first-child {
                color: #333;
              }
            }
          }

          &--down {
            svg {
              path:last-child {
                color: #333;
              }
            }
          }
        }
      }
    }

    &__row {
      &:first-child {
        border-top: 1px solid #e5e5e5;
      }

      border-bottom: 1px solid #e5e5e5;
    }

    &__resizer {
      position: absolute;
      top: 0;
      padding: 0 4px;
      right: -4px;
      cursor: col-resize;
      user-select: none;
      touch-action: none;

      div {
        width: 1px;
        height: 100%;
        background: #e5e5e5;
      }

      &:hover {
        div {
          width: 2px;
          background: #9c9c9c;
        }
      }
    }

    &__loader {
      height: 278px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 8px;
      border-radius: 4px;
      background: #ededed;

      &-spinner {
        width: 50px;
        aspect-ratio: 1;
        border-radius: 50%;
        background: radial-gradient(farthest-side, #1396da 94%, #0000) top/8px 8px no-repeat,
          conic-gradient(#0000 30%, #1396da);
        -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
        animation: l13 1s infinite linear;

        @keyframes l13 {
          100% {
            transform: rotate(1turn);
          }
        }
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global``;
};

export { staticStyles, getDynamicStyles };
